module.exports = __webpack_public_path__ + "static/img/building-bottom.85154a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/building-bottom.jpg
// module id = 322
// module chunks = 64